var React = require('react');

function StartStopMove (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#27788C;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")),React.createElement("g",{"transform":"translate(1 1)","key":1},[React.createElement("path",{"className":"a","d":"M-1607.634-1264.034a18.459,18.459,0,0,0-12.855,17.588,18.452,18.452,0,0,0,18.452,18.451,18.452,18.452,0,0,0,18.451-18.451,18.459,18.459,0,0,0-12.856-17.588","transform":"translate(1620.489 1270.026)","key":0}),React.createElement("line",{"className":"a","y2":"20.487","transform":"translate(18.451)","key":1})])]);
}

StartStopMove.defaultProps = {"width":"38.903","height":"44.031","viewBox":"0 0 38.903 44.031"};

module.exports = StartStopMove;

StartStopMove.default = StartStopMove;
